import React, {Component} from 'react';
import s from './index.module.scss';
import i18next from 'i18next'

import {connect} from 'react-redux';
import actions from '../../redux/action';
import {getQueryVariable} from '../../common/util';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: '', error_description: '',
    };
  }

  formRef = React.createRef();

  componentDidMount() {
    const error = getQueryVariable('error');
    const error_description = getQueryVariable('error_description');
    if (error) {
      this.setState({
        error, error_description,
      }, () => {
        console.log(this.state, 'state in consent');
      });
    }
  }

  render() {
    const { locale } = this.props;
    const { error, error_description } = this.state;

    return (<div>
      <div className={ s.container }>
        <div className={ s.welcome }>
          {i18next.t('home_title')}
        </div>

        <div className={ s.content }>
          <div className={ s.title }>
            { error }
          </div>
          <div className={ s.title }>
            { error_description }
          </div>
        </div>

      </div>
    </div>);
  }
}

const mapStateToProps = state => ({
  locale: state.language.language,
});
const mapDispatchToProps = dispatch => ({
  changeLanguage: val => dispatch(actions.onChangeLanguage(val)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
